import { useRouter } from 'vue-router';

declare global {
    interface Window {
        zs: {
            navigateTo(path: string): void;
        };
    }
}

export function useZSHelpers() {
    const router = useRouter();

    window.zs = {
        navigateTo(path: string) {
            router.push(path);
        }
    };
}
